<div class="container">

  <!-- Logo arriba -->
  <div class="header">
    <img src="assets/images/logo/Logo_AEL.svg" alt="Afiliación en línea" />
  </div>

  <!-- Mensaje -->
  <div class="content">

    <div class="icon">
      <img src="assets/images/svg/action_false.svg" alt="Usuario no permitido" />
    </div>

    <div class="text">
      <h2>Usuario no permitido</h2>
      <p>
        Asegúrate que el usuario finalice el onboarding
        para continuar con el proceso.
      </p>
    </div>

  </div>

</div>